module.exports = __webpack_public_path__ + "static/media/img_24.6425a55d.png";